(() => {
  const desktopMedia = window.matchMedia('(min-width: 1200px)');

  const syncOpenState = () => {
    document.querySelectorAll('.footer-block__collapsible').forEach((collapsible) => {
      collapsible.open = desktopMedia.matches;
    });
  };

  const bindCollapsibles = (root) => {
    root.querySelectorAll('.footer-block__collapsible').forEach((collapsible) => {
      if (collapsible.dataset.collapsibleBound) return;
      collapsible.dataset.collapsibleBound = 'true';
      collapsible.open = desktopMedia.matches;
      collapsible.addEventListener('toggle', () => {
        if (desktopMedia.matches) collapsible.open = true;
      });
    });
  };

  desktopMedia.addEventListener('change', syncOpenState);
  bindCollapsibles(document);
  document.addEventListener('shopify:section:load', (event) => bindCollapsibles(event.target));
})();
